export const MENU_CONFIG = [
  {key: 'MENU.FLATS', route: 'flats'},
  {key: 'MENU.TECHNICAL_DESCRIPTION', route: 'technical-description'},
  {key: 'MENU.GALLERIES', route: 'galleries'},
  {key: 'MENU.MENU_2', route: 'references'},
  {key: 'MENU.SERVICES', route: 'services'},
  {key: 'MENU.MENU_4', route: 'partners'},
  {key: 'MENU.MENU_5', route: 'contact'}
];

